import { useTranslation } from 'react-i18next';
import i18nConfig from '../../i18nConfig';

const useLocalePath = () => {
  const { i18n } = useTranslation();
  const locale = i18n.language;

  return (path: string) =>
    locale === i18nConfig.defaultLocale ? path : `/${locale}${path}`;
};

export default useLocalePath;
